import { useEffect, useRef } from 'react';
import axios from 'axios';
import { toast } from 'sonner';

const SOURCE_ICONS = {
  'Instagram': '📸',
  'TikTok': '🎵',
  'X / Twitter': '𝕏',
  'YouTube': '▶',
  'Facebook': '📘',
  'LinkedIn': '💼',
  'Reddit': '🔗',
  'Google Search': '🔍',
  'Direct': '🌐',
};

export default function LiveClickNotifier() {
  const lastCheckRef = useRef(''); // Empty = first poll uses server default (last 30s)
  const intervalRef = useRef(null);

  useEffect(() => {
    const token = localStorage.getItem('token');
    const session = localStorage.getItem('session_token');
    if (!token) return;

    const poll = async () => {
      try {
        const res = await axios.get(`/creator/recent-clicks?since=${lastCheckRef.current}`, {
          headers: { Authorization: `Bearer ${token}` },
        });

        const { clicks, server_time } = res.data;
        if (server_time) lastCheckRef.current = server_time;

        clicks.reverse().forEach((click) => {
          const icon = SOURCE_ICONS[click.source] || '👁';
          const page = click.product_name
            ? click.product_name
            : click.page_type === 'store'
            ? 'your store'
            : click.page_id;

          toast(`${icon}  Someone from ${click.source} just viewed ${page}`, {
            duration: 5000,
            style: {
              background: '#111',
              border: '1px solid rgba(0,240,255,0.2)',
              color: '#fff',
              fontSize: '13px',
            },
          });
        });
      } catch (_) {
        // silently ignore auth errors / network issues
      }
    };

    // Initial delay 3s, then poll every 15s
    const startTimeout = setTimeout(() => {
      poll();
      intervalRef.current = setInterval(poll, 15000);
    }, 3000);

    return () => {
      clearTimeout(startTimeout);
      if (intervalRef.current) clearInterval(intervalRef.current);
    };
  }, []);

  return null; // Invisible component — only triggers toasts
}
